import { useCallback, useEffect, useState } from 'react';
import { DateRangePicker } from './BigDesignDateRangePicker';
import { FilterFlexItem } from './FilterFlexItem';

export function DateRangeFilter({ onDateRangeChange, value, setDateValue }) {
	const [dateRange, setDateRange] = useState([null, null]);
	const [startDate, endDate] = dateRange;

	const onDateRangeInputChange = useCallback(
		(newDates) => {
			const [newStartDate, newEndDate] = newDates || [null, null];

			setDateRange(newDates || [null, null]);
			if (setDateValue) setDateValue(newDates || [null, null]);
			onDateRangeChange(newStartDate, newEndDate);
		},
		[onDateRangeChange],
	);

	useEffect(() => {
		if (value.includes(null) && !dateRange.includes(null))
			setDateRange([null, null]);
	}, [value, dateRange]);

	return (
		<FilterFlexItem className="filtered-date-container">
			<DateRangePicker
				selected={startDate}
				onChange={onDateRangeInputChange}
				startDate={startDate}
				endDate={endDate}
				selectsRange={true}
				isClearable={true}
				dateFormat="MM/dd/yyyy"
				placeholderText="Filter by Date Range"
			/>
		</FilterFlexItem>
	);
}
